<template>
  <b-tag v-show="number>0" rounded>{{ number.toLocaleString() }}</b-tag>
</template>

<script>
  export default {
    props: ['number'],
  }
</script>
